import clsx from 'clsx';

// This component SHOULD NOT have any styles built in
// Maybe something like <b> tag if ever needed

// The only reason this exists as a component instead of just a string are the line breaks
export const LoanExampleText = (props: { className?: string }) => {
  return (
    <div className={clsx('whitespace-pre-line', props.className)}>
      <p className="m-0">
        Prisene varierer mellom bankene og fra kunde til kunde. Priseksempel: 240.000 over 5 år,
        effektiv rente 12,69%, kostnad 77.940. Totalkostnad 317.940
      </p>
      <p className="m-0 mt-[0.75em]">
        Løpetid er fra 0-15år – Høyeste rente er 24,6% og laveste er 7,9%
      </p>
    </div>
  );
};
